import { EventType } from "@/common/types"
import useListEventTypes from "@/hooks/api/events/useListEventTypes"
import useIsMobile from "@/hooks/useIsMobile"
import { Box, Chip, Stack, Typography } from "@mui/material"

export default function ExperienceCollectionFilters() {
  const isMobile = useIsMobile()
  const { data: eventTypes, isLoading } = useListEventTypes()
  if (isLoading) {
    return <>Loading...</>
  }

  return (
    <Stack>
      {!isMobile && (
        <Typography variant="h2" sx={{ fontWeight: "bold", marginBottom: 2 }}>
          Experiences Collected
        </Typography>
      )}
      <Stack
        direction={isMobile ? "row" : "column"}
        gap={2}
        width={isMobile ? "100%" : "50%"}
        sx={{ overflowX: "auto", whiteSpace: "nowrap" }}
      >
        {eventTypes.eventTypes.map((eventType: EventType) => (
          <Chip
            key={eventType.event_type_id}
            variant="outlined"
            sx={{
              border: "1px solid #F0F2F5",
              color: "white",
              borderRadius: "20px",
              minWidth: 120,
              paddingY: 1,
              display: "flex",
              justifyContent: "space-between",
              "& .MuiChip-label": {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "-webkit-fill-available", // This stretches the label
              },
            }}
            label={
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                width="100%"
              >
                <Typography>{eventType.human_name}</Typography>
                <Typography sx={{ marginLeft: "auto" }}>0</Typography>
              </Box>
            }
          />
        ))}
      </Stack>
    </Stack>
  )
}

{
  /* </Chip> */
}
{
  /* <Typography color={"white"}>{eventType.human_name}</Typography> */
}
{
  /* <Typography color={"white"}>0</Typography> */
}
